<template>
  <div>
    <md-button
      class="md-just-icon md-success md-simple table-action"
      @click="confirmDetailSms"
    >
      <md-tooltip md-direction="top">{{ $t("common.view") }} </md-tooltip>
      <md-icon>visibility</md-icon>
    </md-button>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
  inject: ["detailSms"],
  methods: {
    confirmDetailSms() {
      this.detailSms(this.item);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
